const ALLOWED_SERVICE_TYPES = ['Installation', 'Repair', 'Maintenance', 'Other']
const ALLOWED_CONTACT_METHODS = ['Phone', 'Email', 'No Preference']

export function sanitize(str) {
  if (typeof str !== 'string') return ''
  return str
    .replace(/<[^>]*>/g, '')
    .replace(/javascript:/gi, '')
    .replace(/on\w+\s*=/gi, '')
    .replace(/data:text\/html/gi, '')
    .trim()
}

export function truncate(str, max) {
  return typeof str === 'string' ? str.slice(0, max) : ''
}

export function isValidEmail(email) {
  return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)
}

export function isValidPhone(phone) {
  const digits = phone.replace(/[\s\-().+]/g, '')
  return /^\d{7,15}$/.test(digits)
}

export function isValidName(name) {
  return /^[a-zA-ZÀ-ÿ\s\-']{2,100}$/.test(name)
}

export function isValidServiceType(type) {
  return ALLOWED_SERVICE_TYPES.includes(type)
}

export function isValidContactMethod(method) {
  return ALLOWED_CONTACT_METHODS.includes(method)
}

export function sanitizeForm(form) {
  const sanitized = {
    name: truncate(sanitize(form.name), 100),
    phone: truncate(sanitize(form.phone), 20),
    email: truncate(sanitize(form.email), 254),
    serviceType: sanitize(form.serviceType),
    contactMethod: sanitize(form.contactMethod),
    message: truncate(sanitize(form.message), 1000),
  }

  const errors = {}

  if (!sanitized.name || !isValidName(sanitized.name)) {
    errors.name = 'Please enter your full name.'
  }
  if (!sanitized.phone || !isValidPhone(sanitized.phone)) {
    errors.phone = 'Please enter a valid phone number.'
  }
  if (!sanitized.email || !isValidEmail(sanitized.email)) {
    errors.email = 'Please enter a valid email address.'
  }
  if (!isValidServiceType(sanitized.serviceType)) {
    errors.serviceType = 'Please select a service type.'
  }
  if (!isValidContactMethod(sanitized.contactMethod)) {
    errors.contactMethod = 'Please select a preferred contact method.'
  }

  return { sanitized, errors, isValid: Object.keys(errors).length === 0 }
}
